import React, { useState } from "react";
import { toast } from "sonner";
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogFooter } from "@/components/ui/dialog";
import { Button } from "@/components/ui/button";
import { Textarea } from "@/components/ui/textarea";
import { StarRating } from "@/components/StarRating";
import { api } from "@/lib/api";

export default function FeedbackModal({ open, item, onClose, onSubmitted }) {
  const [rating, setRating] = useState(0);
  const [text, setText] = useState("");
  const [busy, setBusy] = useState(false);

  const reset = () => { setRating(0); setText(""); };

  const submit = async () => {
    if (!item) return;
    if (rating < 1 || rating > 5) return toast.error("Pick 1–5 stars");
    setBusy(true);
    try {
      await api.createFeedback({
        opportunity_id: item.opportunity_id,
        to_user_id: item.to_user_id,
        rating,
        text: text.trim() || undefined,
      });
      toast.success("Feedback sent");
      reset();
      onClose?.();
      onSubmitted?.();
    } catch (e) {
      toast.error(e?.response?.data?.detail || "Could not send feedback");
    } finally {
      setBusy(false);
    }
  };

  return (
    <Dialog open={open} onOpenChange={(v) => !v && (reset(), onClose?.())}>
      <DialogContent data-testid="feedback-modal" className="sm:max-w-md">
        <DialogHeader>
          <DialogTitle>Leave feedback</DialogTitle>
        </DialogHeader>
        <div className="text-sm text-neutral-700 -mt-2">
          {item?.opportunity_title && (
            <div className="text-xs text-neutral-500">for <b>{item.opportunity_title}</b></div>
          )}
          {item?.to_user_name && (
            <div className="text-xs text-neutral-500 mt-0.5">reviewing <b>{item.to_user_name}</b></div>
          )}
        </div>
        <div className="mt-2 space-y-3">
          <div>
            <div className="text-xs uppercase tracking-wide text-forest/70 font-bold mb-1">Rating</div>
            <StarRating value={rating} onChange={setRating} size={30} />
          </div>
          <div>
            <div className="text-xs uppercase tracking-wide text-forest/70 font-bold mb-1">Comment</div>
            <Textarea
              data-testid="feedback-text"
              value={text}
              onChange={(e) => setText(e.target.value.slice(0, 2000))}
              placeholder="What went well? Anything they should improve?"
              rows={4}
            />
            <div className="text-[11px] text-neutral-500 text-right mt-1">{text.length}/2000</div>
          </div>
        </div>
        <DialogFooter>
          <Button variant="outline" onClick={() => { reset(); onClose?.(); }} className="rounded-full">Cancel</Button>
          <Button data-testid="feedback-submit" onClick={submit} disabled={busy || rating < 1} className="rounded-full bg-forest hover:bg-forest-hover">
            {busy ? "Sending…" : "Send feedback"}
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
}
